<template>
  <!-- <v-app> -->
  <v-card flat color="transparent">
    <v-subheader>Minimum/Maximum Loan Amount ($) :</v-subheader>
    <v-card-text style="width: 270px">
      <v-range-slider
        v-model="valueMulti"
        style="width: 260px"
        :ripple="false"
        :min="0"
        :max="2000000"
        :step="1"
      >
      </v-range-slider>
      <v-row align="center" no-gutters>
        <v-col cols="6">
          Min ($)
          <v-text-field
            v-model="valueMulti[0]"
            class="pr-2"
            hide-details
            single-line
            type="number"
            variant="outlined"
            density="compact"
            @input="(event) => MinValueFn()"
            style="width: 120px"
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          Max ($)
          <v-text-field
            v-model="valueMulti[1]"
            hide-details
            single-line
            type="number"
            :max="2000000"
            variant="outlined"
            style="width: 120px"
            @input="(event) => MaxValueFn()"
            @keydown.enter.prevent="enterHitFn"
            density="compact"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
    <!-- <v-sheet class="d-flex mb-6 bg-surface-variant"> -->
    <!-- <v-sheet class="ma-2 pa-2 me-auto"
        >Min ($) {{ Math.round(this.valueMulti[0]) }}</v-sheet
      > -->
    <!-- <v-sheet class="ma-2 pa-2"
        >Max ($) {{ Math.round(this.valueMulti[1]) }}</v-sheet
      > -->
    <!-- <v-sheet class="ma-2 pa-2 me-auto">
        <v-text-field
          label="Min ($)"
          v-model="loan.min"
          style="width: 100px"
          @change="abccall()"
          hide-details
        ></v-text-field>
      </v-sheet>
      <v-sheet class="ma-2 pa-2">
        <v-text-field
          label="Max ($)"
          v-model="loan.max"
          hide-details
          @change="abccall()" 
          style="width: 100px"
        ></v-text-field> -->
    <!-- <v-text-field label="Minimum">
          Max ($) {{ Math.round(this.valueMulti[1]) }}
        </v-text-field> -->
    <!-- </v-sheet> -->
    <!-- </v-sheet> -->
    <!-- <p>Min ($) {{ Math.round(this.valueMulti[0]) }}</p>
      <p>Max ($) {{ Math.round(this.valueMulti[1]) }}</p> -->
  </v-card>
  <!-- </v-app> -->
</template>
<script>
import { useStore } from "vuex";
export default {
  data() {
    return {
      valueMulti: [0, 2000000],
      // min: 0,
      // max: 2000000,
      loan: {},
      max: 2000000,
      min: 0,
      store: useStore(),
    };
  },
  // watchEffect(() => {
  //   console.log(store.getters["Sector/getLoanAmount"], 88);
  // })

  watch: {
    valueMulti(newValue, oldValue) {
      console.log(newValue, oldValue);
      this.store.dispatch("Sector/setLoanAmount", newValue);
    },
  },
  beforeMount() {
    this.loan = this.store.getters["Sector/getLoanAmount"];
    console.log("Begre mount", this.loan.min);
    let min = this.loan.min;
    let max = this.loan.max;
    this.valueMulti[0] = min;
    this.valueMulti[1] = max;
    // this.valueMulti = this.loan;
  },
  methods: {
    MinValueFn() {
      this.MinValueFn[0] = Number(this.MinValueFn[0]);
      // console.log(this.valueMulti, "min");
      if (Number(this.valueMulti[0]) > Number(this.valueMulti[1])) {
        alert("Minimum amount should be less than Maximum amount.");
        this.valueMulti[0] = 0;
      } else if (Number(this.valueMulti[0]) < 0) {
        alert("Minimum amount should be numeric value.");
        this.valueMulti[0] = 0;
      } else if (!this.valueMulti[0]) {
        setTimeout(() => {
          if (!this.valueMulti[0]) {
            this.valueMulti[0] = 0;
          }
        }, 2000);
      }
      this.valueMulti[1] = 2000000;
      console.log(this.valueMulti, "min");
      this.store.dispatch("Sector/setLoanAmount", this.valueMulti);
    },
    MaxValueFn() {
      // console.log(this.valueMulti, "max");
      this.MinValueFn[1] = Number(this.MinValueFn[1]);
      if (Number(this.valueMulti[1]) < 0) {
        alert("Maximum amount should be numeric value.");
        this.valueMulti[1] = 2000000;
      } else if (Number(this.valueMulti[1]) > 2000000) {
        this.valueMulti[1] = 2000000;
      } else if (!this.valueMulti[1]) {
        setTimeout(() => {
          this.valueMulti[1] = 2000000;
        }, 2000);
      } else if (Number(this.valueMulti[0]) > Number(this.valueMulti[1])) {
        alert("Minimum amount should be less than Maximum amount.");
        this.valueMulti[1] = 2000000;
      }
      this.store.dispatch("Sector/setLoanAmount", this.valueMulti);
      // console.log(this.valueMulti, "max");
    },
    enterHitFn() {
      this.store.dispatch("Rawdata/setsearchBtnFlag", true);
    },
  },
  // watch: {
  //   valueMulti: function (val) {
  //     console.log(val, "val");
  //     this.loan.min = val[0];
  //     this.loan.max = val[1];
  //     this.max = val[1];
  //     if (this.min > this.max) {
  //       alert("Minimum amount should be less than Maximum amount.");
  //       this.loan.min = 0;
  //       this.loan.max = 2000000;
  //     }
  //     this.store.dispatch("Sector/setLoanAmount", val);
  //   },
  // max: function (l) {
  //   console.log(l);
  //   if (l > 2000000) {
  //     alert("not higher");
  //   }
  // },
  // max: function () {
  //   if (this.min > this.max) {
  //     alert("min is higher than max");
  //   }
  // },
  // },
};
</script>
